// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import AppstoreOutlinedSvg from "@ant-design/icons-svg/es/asn/AppstoreOutlined";
import AntdIcon from '../components/AntdIcon';

var AppstoreOutlined = function AppstoreOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: AppstoreOutlinedSvg
  }));
};

AppstoreOutlined.displayName = 'AppstoreOutlined';
export default React.forwardRef(AppstoreOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/AppstoreOutlined.js
// module id = 587
// module chunks = 0